import React from 'react';
import loadable from '@loadable/component';

import { FormattedMessage, useIntl } from '../../util/reactIntl';

import css from './FallbackPage.module.css';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Create fallback content (array of sections) in page asset format:
export const fallbackSections = intl => ({
  sections: [
    {
      sectionType: 'customMaintenance',
      sectionId: 'maintenance-mode',
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: intl.formatMessage({ id: 'MaintenanceMode.title' }),
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: intl.formatMessage({ id: 'MaintenanceMode.info' }),
    },
  },
});

const SectionMaintenanceMode = props => {
  const { sectionId } = props;

  return (
    <section id={sectionId} className={css.root}>
      <div className={css.content}>
        <h2>
          <FormattedMessage id="MaintenanceMode.title" />
        </h2>
        <p>
          <FormattedMessage id="MaintenanceMode.info" />
          <br />
          <FormattedMessage id="MaintenanceMode.howToProceed" />
        </p>
      </div>
    </section>
  );
};

// This is the fallback page, in case there's no Landing Page asset defined in Console.
const FallbackPage = props => {
  const intl = useIntl();
  return (
    <PageBuilder
      pageAssetsData={fallbackSections(intl)}
      options={{
        sectionComponents: {
          customMaintenance: { component: SectionMaintenanceMode },
        },
      }}
      {...props}
    />
  );
};

export default FallbackPage;
